// RustFS は ETag をヘッダーではなく、201 応答の XML 本文に返す。
export const uploadS3Post = ({ signature, body, size, onProgress, onComplete, signal }) => {
    return new Promise((resolve, reject) => {
        var _a, _b;
        const xhr = new XMLHttpRequest();
        const abort = () => { xhr.abort(); };
        const cleanup = () => { signal === null || signal === void 0 ? void 0 : signal.removeEventListener('abort', abort); };
        const fail = (error) => {
            cleanup();
            reject(error);
        };
        if (signal === null || signal === void 0 ? void 0 : signal.aborted) {
            reject(new DOMException('Upload aborted', 'AbortError'));
            return;
        }
        xhr.open('POST', signature.url, true);
        xhr.timeout = ((_a = signature.expires) !== null && _a !== void 0 ? _a : 300) * 1000;
        for (const [key, value] of Object.entries((_b = signature.headers) !== null && _b !== void 0 ? _b : {})) {
            xhr.setRequestHeader(key, value);
        }
        xhr.upload.addEventListener('progress', onProgress);
        xhr.addEventListener('abort', () => { fail(new DOMException('Upload aborted', 'AbortError')); });
        xhr.addEventListener('error', () => { fail(new Error('S3 upload failed')); });
        xhr.addEventListener('timeout', () => { fail(new Error('S3 upload timed out')); });
        xhr.addEventListener('load', () => {
            var _a, _b;
            cleanup();
            if (xhr.status < 200 || xhr.status >= 300) {
                reject(Object.assign(new Error(`S3 upload failed: ${xhr.status}`), { source: xhr }));
                return;
            }
            const xml = new DOMParser().parseFromString(xhr.responseText, 'application/xml');
            const etag = xhr.getResponseHeader('ETag') || ((_a = xml.querySelector('PostResponse > ETag')) === null || _a === void 0 ? void 0 : _a.textContent);
            const location = xhr.getResponseHeader('Location') || ((_b = xml.querySelector('PostResponse > Location')) === null || _b === void 0 ? void 0 : _b.textContent);
            if (!etag) {
                reject(new Error('S3 upload response has no ETag'));
                return;
            }
            onProgress === null || onProgress === void 0 ? void 0 : onProgress({ loaded: size, lengthComputable: true });
            onComplete === null || onComplete === void 0 ? void 0 : onComplete(etag);
            resolve({ ETag: etag, ...(location ? { location: new URL(location, signature.url).href } : {}) });
        });
        signal === null || signal === void 0 ? void 0 : signal.addEventListener('abort', abort);
        xhr.send(body);
    });
};
